import script from "./ApplyList.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyList.vue?vue&type=script&setup=true&lang=js"

import "./ApplyList.vue?vue&type=style&index=0&id=3997a655&lang=less"

const __exports__ = script;

export default __exports__